"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipPlace = exports.TooltipMode = void 0;
var TooltipMode;
(function (TooltipMode) {
    TooltipMode["LIGHT"] = "light";
    TooltipMode["DARK"] = "dark";
})(TooltipMode || (exports.TooltipMode = TooltipMode = {}));
var TooltipPlace;
(function (TooltipPlace) {
    TooltipPlace["TOP"] = "top";
    TooltipPlace["TOP_END"] = "top-end";
    TooltipPlace["TOP_START"] = "top-start";
    TooltipPlace["BOTTOM"] = "bottom";
    TooltipPlace["BOTTOM_END"] = "bottom-end";
    TooltipPlace["BOTTOM_START"] = "bottom-start";
    TooltipPlace["RIGHT"] = "right";
    TooltipPlace["RIGHT_END"] = "right-end";
    TooltipPlace["RIGHT_START"] = "right-start";
    TooltipPlace["LEFT"] = "left";
    TooltipPlace["LEFT_END"] = "left-end";
    TooltipPlace["LEFT_START"] = "left-start";
})(TooltipPlace || (exports.TooltipPlace = TooltipPlace = {}));
